(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-collagen"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
    WT_Swipers.init();
  } else {
    document.addEventListener("wt:swiper:ready", () => {
      if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
        WT_Swipers.init();
      }
    });
  }

  const sectionId = "{{ section.id }}";
  
  if (window.YD_PDP_VideoSlider) {
    window.YD_PDP_VideoSlider.initNavigation({
      rootId: `yellowday-photo-reels-collagen-${sectionId}`,
      navPrevClass: `wt-slider__nav-prev--collagen-${sectionId}`,
      navNextClass: `wt-slider__nav-next--collagen-${sectionId}`
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-completebiotic"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
    WT_Swipers.init();
  } else {
    document.addEventListener("wt:swiper:ready", () => {
      if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
        WT_Swipers.init();
      }
    });
  }

  const sectionId = "{{ section.id }}";
  
  if (window.YD_PDP_VideoSlider) {
    window.YD_PDP_VideoSlider.initNavigation({
      rootId: `yellowday-photo-reels-completebiotic-${sectionId}`,
      navPrevClass: `wt-slider__nav-prev--completebiotic-${sectionId}`,
      navNextClass: `wt-slider__nav-next--completebiotic-${sectionId}`
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-detox"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
    WT_Swipers.init();
  } else {
    document.addEventListener("wt:swiper:ready", () => {
      if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
        WT_Swipers.init();
      }
    });
  }

  const sectionId = "{{ section.id }}";
  
  if (window.YD_PDP_VideoSlider) {
    window.YD_PDP_VideoSlider.initNavigation({
      rootId: `yellowday-photo-reels-detox-${sectionId}`,
      navPrevClass: `wt-slider__nav-prev--detox-${sectionId}`,
      navNextClass: `wt-slider__nav-next--detox-${sectionId}`
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hormonal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
    WT_Swipers.init();
  } else {
    document.addEventListener("wt:swiper:ready", () => {
      if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
        WT_Swipers.init();
      }
    });
  }

  const sectionId = "{{ section.id }}";
  
  if (window.YD_PDP_VideoSlider) {
    window.YD_PDP_VideoSlider.initNavigation({
      rootId: `yellowday-photo-reels-hormonal-${sectionId}`,
      navPrevClass: `wt-slider__nav-prev--hormonal-${sectionId}`,
      navNextClass: `wt-slider__nav-next--hormonal-${sectionId}`
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-menopause"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
    WT_Swipers.init();
  } else {
    document.addEventListener("wt:swiper:ready", () => {
      if (window.WT_Swipers && typeof WT_Swipers.init === "function") {
        WT_Swipers.init();
      }
    });
  }

  const sectionId = "{{ section.id }}";
  
  if (window.YD_PDP_VideoSlider) {
    window.YD_PDP_VideoSlider.initNavigation({
      rootId: `yellowday-photo-reels-menopause-${sectionId}`,
      navPrevClass: `wt-slider__nav-prev--menopause-${sectionId}`,
      navNextClass: `wt-slider__nav-next--menopause-${sectionId}`
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
